import { trackedLazy, TrackedSuspense } from '../lib/tracked-lazy';

import { ErrorBoundary } from './ErrorBoundary';

export function universal(load) {
  const Cmp = trackedLazy(load);
  return (props) => (
    <ErrorBoundary contentTypeId={props.contentTypeId}>
      {/** * Showing a loading animation of all of these is distracting and looks
      * buggy. Instead just leave it empty with 0 height. It's rare that this *.
      will actually be rendered for more than a fraction of a second. */}
      <TrackedSuspense fallback={<></>}>
        <Cmp {...props} />
      </TrackedSuspense>
    </ErrorBoundary>
  );
}

export const Callout = universal(() => import('./Callout'));
export const ComposableCallout = universal(() => import('./ComposableCallout'));
export const Html = universal(() => import('./Html'));
export const Feature = universal(() => import('./Feature'));
export const FinishRegistration = universal(
  () => import('./FinishRegistration')
);
export const GameDetailScreenV2 = universal(
  () => import('./GameDetailScreenV2')
);
export const GameDirectory = universal(() => import('./GameDirectory'));
export const GetApp = universal(() => import('./GetApp'));
export const HeaderText = universal(() => import('./HeaderText'));
export const Hero = universal(() => import('./Hero'));
export const HighlightedCallout = universal(
  () => import('./HighlightedCallout')
);
export const HighlightedRow = universal(() => import('./HighlightedRow'));
export const InterpolatedString = universal(
  () => import('./InterpolatedString')
);
export const LearnMore = universal(() => import('./LearnMore'));
export const MembershipDetails = universal(() => import('./MembershipDetails'));
export const MembershipOffer = universal(() => import('./MembershipOffer'));
export const ParagraphText = universal(() => import('./ParagraphText'));
export const PartitionedCallout = universal(
  () => import('./PartitionedCallout')
);
export const PaybetSuccess = universal(() => import('./PaybetSuccess'));
export const PlainContent = universal(() => import('./PlainContent'));
export const PressLogos = universal(() => import('./PressLogos'));
export const ProductHero = universal(() => import('./ProductHero'));
export const ResponsiveHeroImage = universal(
  () => import('./ResponsiveHeroImage')
);
export const SimpleCta = universal(() => import('./SimpleCta'));
export const Stats = universal(() => import('./Stats'));
export const SvgIcon = universal(() => import('./SvgIcon'));
export const TestimonialCarousel = universal(
  () => import('./TestimonialCarousel')
);
export const UserProfile = universal(() => import('./UserProfile'));
export const WaybetterWay = universal(() => import('./WaybetterWay'));

export const ExpandableContent = universal(() => import('./ExpandableContent'));

export { RowContext } from './RowContext.js';
